import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { departmentDashboard } from '../../actions/constant';
import departmentDashboardService from '../../../services/departmentDashboard/getDepartmentDashboardCount';
const {
  GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE,
  GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS,
  GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST,
} = departmentDashboard;

function* getDepartmentDashboardCount(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(departmentDashboardService.getDepartmentDashboardCount);
    if (response?.status === 200) {
      yield put({ type: GET_DEPARTMENT_DASHBOARD_COUNT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DEPARTMENT_DASHBOARD_COUNT_FAILURE, payload: error });
  }
}

function* getDepartmentDashboardCountSaga() {
  yield takeEvery(GET_DEPARTMENT_DASHBOARD_COUNT_REQUEST, getDepartmentDashboardCount);
}

export default getDepartmentDashboardCountSaga;
